import React from "react";
import { Gauge, LayoutDashboard, Radio, Satellite, SlidersHorizontal, TerminalSquare, Zap } from "lucide-react";

const menuItems = [
  { label: "Dashboard", description: "Resumen TX/RX", icon: LayoutDashboard },
  { label: "EPS", description: "Energía", icon: Zap },
  { label: "Telemetría", description: "Sensores", icon: Gauge },
  { label: "Comunicaciones", description: "Protocolos", icon: Radio },
  { label: "Payload", description: "Carga útil", icon: Satellite },
  { label: "Operación", description: "Modo y PING", icon: SlidersHorizontal },
  { label: "Monitor Serial", description: "Puerto COM", icon: TerminalSquare },
];

const MenuBar = ({ selectedIndex, onButtonClick }) => {
  return (
    <nav className="obc-menu" aria-label="Menú principal de la OBC">
      {menuItems.map((item, index) => {
        const Icon = item.icon;
        const isSelected = selectedIndex === index;

        return (
          <button
            key={item.label}
            type="button"
            onClick={() => onButtonClick(index)}
            className={`obc-menu-button ${isSelected ? "is-active" : ""}`}
            aria-pressed={isSelected}
          >
            <span className="obc-menu-icon"><Icon size={20} /></span>
            <span className="obc-menu-text">
              <strong>{item.label}</strong>
              <small>{item.description}</small>
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default MenuBar;
